export default __webpack_public_path__ + "static/media/premium@2x.6577c2c4.png";